"use strict";
import { call, select } from "typed-redux-saga";
import { ALL_CHAIN_IDS } from "features/chains/types";
import { getEnabledChains } from "features/chains/utils";
import { selectIsTestnetModeEnabled } from "features/settings/selectors";
export function* getEnabledChainIdsSaga() {
  const isTestnetModeEnabled = yield* select(selectIsTestnetModeEnabled);
  return yield* call(getEnabledChains, {
    isTestnetModeEnabled,
    featureFlaggedChainIds: ALL_CHAIN_IDS
  });
}
